import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { servicesApi as r } from "@maat/api-main";
//#region src/services/useCreateServiceListingMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ serviceId: e, data: t }) => r.createServiceListing(e, t),
		onSuccess: (t, { serviceId: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreateServiceListingMutation };
